import { dmApi } from "../dmApi";
import { getAuthorizationHeader } from "../../helpers/RtkQueryUtils";

const RedemptionApi = dmApi.injectEndpoints({
  endpoints: (build) => ({
    getRedemptionCodes: build.query({
      query: ({ page = 1, limit = 50, search, status, ids } = {}) => {
        const params = new URLSearchParams();
        params.set("page", String(page));
        params.set("limit", String(limit));
        if (search && String(search).trim()) params.set("search", String(search).trim());
        if (status && status !== "all") params.set("status", status);
        if (Array.isArray(ids) && ids.length > 0) params.set("ids", ids.join(","));
        return {
          url: `/subscription/admin/redemption-codes?${params.toString()}`,
          method: "GET",
          headers: getAuthorizationHeader(),
        };
      },
      providesTags: ["getRedemptionCodesApi"],
    }),
    createRedemptionCode: build.mutation({
      query: (body) => ({
        url: "/subscription/admin/redemption-codes",
        method: "POST",
        body,
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ["getRedemptionCodesApi"],
    }),
    updateRedemptionCodeStatus: build.mutation({
      query: (body) => ({
        url: "/subscription/admin/redemption-codes/status",
        method: "PATCH",
        body,
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ["getRedemptionCodesApi"],
    }),
  }),
});

export const {
  useGetRedemptionCodesQuery,
  useCreateRedemptionCodeMutation,
  useUpdateRedemptionCodeStatusMutation,
} = RedemptionApi;
